module.exports = __webpack_public_path__ + "static/media/setting-default.7b397430.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/setting-default.svg
// module id = 1220
// module chunks = 0